import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Page from "../Page/Page";

import "../../Styles/BookAction.css";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import Action from "../../Components/Common/Action";
import Audio from "../../Components/Common/Audio";
import { Transaction_Forum } from "../../Connections/Transaction";
import LoadingSpinner from "../../Components/Common/LoadingSpinner";

const BookAction = (props) => {
  const pageSize = 10;
  const navigator = useNavigate();
  const params = useParams();
  const { state } = useLocation();

  // =================================================

  const [showingAction, setShowingAction] = useState(state?.actionId);
  useEffect(() => {
    if (showingAction === undefined) {
      setShowingAction(5);
    }
  }, []);
  const [bookActions, setBookActions] = useState([]);
  const [bookInfo, setBookInfo] = useState({});
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  // =================================================

  const getActions = () => {
    Transaction_Forum.GetOneBookForumActions(
      params.id,
      showingAction,
      undefined,
      page,
      pageSize
    )
      .then((res) => {
        if (res[0]) {
          setBookActions(res[2].data.items);
          setTotalItems(res[2].data.paging.totalItems);
        } else {
          setBookActions([]);
        }
      })
      .catch((err) => console.log(err));
  };
  //=================================================
  const [moreBtnLoading, setMoreBtnLoading] = useState(false);
  const getActionsPage = () => {
    setMoreBtnLoading(true);
    Transaction_Forum.GetOneBookForumActions(
      params.id,
      showingAction,
      undefined,
      page + 1,
      pageSize
    )
      .then((res) => {
        if (res[0]) {
          setBookActions([...bookActions, ...res[2].data.items]);
          setMoreBtnLoading(false);
          setPage(page + 1);
        }
      })
      .catch((err) => {
        console.log(err);
        setMoreBtnLoading(false);
      });
  };
  // =================================================

  useEffect(() => {
    Transaction_Forum.GetOneBookForum(params.id)
      .then((res) => {
        if (res[0]) {
          setBookInfo(res[2].data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    getActions();
  }, [showingAction]);

  //audio id
  const [audioId, setAudioId] = useState(0);

  return (
    <Page>
      <MobileNavBar text={"بلاگ"} action={() => navigator(`/hisstori/blog`)} />
      <div
        className="BookAction_wrapper"
        style={showingAction == "podcast" ? { paddingBottom: 150 } : null}
      >
        <div
          className="BookAction_back-arrow mobile-hidden"
          onClick={() => navigator(`/hisstori/blog`)}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            />
          </svg>
        </div>
        <div className="BookAction_content">
          <div className="BookAction_top">
            <div className="BookAction_right">
              <ul className="BookAction_right-tabs-wrapper">
                {bookInfo.actions?.map((item) => (
                  <li
                    onClick={() => setShowingAction(item.actionId)}
                    className={showingAction == item.actionId ? "active" : ""}
                  >
                    {item.title}
                  </li>
                ))}
              </ul>
            </div>
            <div className="BookAction_left">
              <img
                src="/imgs/Blog/Blog-action-header-bg.png"
                alt="background image"
                className="BookAction_left-bg"
              />
              <img
                src={bookInfo.pic}
                alt={bookInfo.title}
                className="BookAction_left-book-img"
              />
              <h1 className="desktop-hidden">{bookInfo.title}</h1>
              <p className="desktop-hidden">{bookInfo.title2}</p>
            </div>
          </div>
          <div className="BookAction_actions-container">
            {bookActions.map((item) => (
              <Action
                audioId={audioId}
                setAudioId={setAudioId}
                key={item.id}
                userInfo={{
                  name: item.userName,
                  img: item.userAvatar,
                  date: item.date,
                }}
                podcast={true}
                reply={false}
                title={item.title}
                hashtags={item.hashtags}
                text={item.description}
                dislikeCount={item.numberOfDisLike}
                commentCount={item.numberOfComment}
                likeCount={item.numberOfLike}
                GetAgainList={getActions}
                id={item.id}
                userId={item.userId}
                actionId={params.id}
                pageAction={showingAction}
              >
                {item.fileType == "Audio" ? (
                  <Audio
                    itemId={item.id}
                    audioId={audioId}
                    setAudioId={setAudioId}
                    audioSrc={item.file}
                  />
                ) : showingAction != 0 ? (
                  <img
                    className="w-100 h-100"
                    style={{ borderRadius: 10 }}
                    src={item.file}
                    alt=" "
                  />
                ) : null}
              </Action>
            ))}
          </div>
          {bookActions.length < totalItems && (
            <div className="BookAction-button" onClick={() => getActionsPage()}>
              {moreBtnLoading ? (
                <div className="book-loading-button">
                  <LoadingSpinner />
                </div>
              ) : (
                <button className="BookAction-button-text">موارد بیشتر</button>
              )}
            </div>
          )}
        </div>
      </div>
    </Page>
  );
};

export default BookAction;
